// Components/ui
import { Modal, Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/system';
import { Mails, Phones, RCSs, Whatsapps } from './components';
// Hooks
import { InformationSocialNetworkItem } from './layout';
import { useEditEntity } from '../../../../../context/EditEntityContext';
import { useTranslationContext } from '../../../../../context/TranslationContext';

interface EditModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const StyledModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1000,
  backgroundColor: theme.palette.background.panel,
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
}));

const EditModal: React.FC<EditModalProps> = ({ open, onClose, title }) => {
  const t = useTranslationContext();
  const { editEntity } = useEditEntity();
  const { emails, phoneNumbers, imsWhatsapp, imsRCS } = editEntity.field;
  const { addEmail, addPhone, addWhatsapp, resetToInitialContactInformation, addRCS } =
    editEntity.action;

  function handleClose() {
    onClose();
    resetToInitialContactInformation();
  }

  const renderContent = () => {
    switch (title) {
      case 'Phones':
        return <Phones handleAdd={addPhone} phoneNumbers={phoneNumbers} />;
      case 'Emails':
        return <Mails handleAdd={addEmail} emails={emails} />;

      case 'Whatsapp':
        return <Whatsapps handleAdd={addWhatsapp} whatsapps={imsWhatsapp} />;
      case 'RCS':
        return <RCSs handleAdd={addRCS} RCSs={imsRCS} />;

      case 'Facebook':
        return (
          <InformationSocialNetworkItem
            title={'Facebook'}
            IMSs={editEntity.field.imsFacebooks}
            editEntity={editEntity}
          />
        );
      case 'Webchat':
        return (
          <InformationSocialNetworkItem
            title={'Webchat'}
            IMSs={editEntity.field.imsWebchats}
            editEntity={editEntity}
          />
        );
      case 'Instagram':
        return (
          <InformationSocialNetworkItem
            title={'Instagram'}
            IMSs={editEntity.field.imsInstagrams}
            editEntity={editEntity}
          />
        );
      case 'Mercado libre':
        return (
          <InformationSocialNetworkItem
            title={'Mercado Libre'}
            IMSs={editEntity.field.imsMercadolibre}
            editEntity={editEntity}
          />
        );
      default:
        return <Typography>No information available for this section.</Typography>;
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <StyledModalContent>
        {renderContent()}
        <Box mt={2} display={'flex'} justifyContent={'flex-end'}>
          <Button variant="contained" color="primary" onClick={handleClose}>
            {t('global.close')}
          </Button>
        </Box>
      </StyledModalContent>
    </Modal>
  );
};

export default EditModal;
